import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { A11yModule } from "@angular/cdk/a11y";
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatIconModule } from '@angular/material/icon';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatTooltipModule } from '@angular/material/tooltip';
import { LicencasService } from 'src/app/shared/api/licencas/licencas.service';
import { MetadadosService } from 'src/app/shared/api/metadados';
import { JogadaService } from 'src/app/shared/api/testes/jogada.service';
import { DialogService } from 'src/app/shared/services/dialog.service';
import { SafeUrlPipe } from 'src/app/shared/services/safe-url.pipe';
import { CardModule } from '../../shared/components/card/card.module';
import { ContainerPadraoModule } from '../../shared/components/container-padrao/container-padrao.module';
import { FormularioDinamicoModule } from '../../shared/components/formulario-dinamico/formulario-dinamico.module';
import { LoaderPageModule } from '../../shared/components/loader-page/loader-page.module';
import { TabelaListagemModule } from '../../shared/components/tabela-listagem/tabela-listagem.module';
import { ToolbarModule } from '../../shared/components/toolbar/toolbar.module';
import { StatusBadgeModule } from '../../shared/components/status-badge/status-badge.module';
import { CardCheckoutGreenComponent } from './card-checkout-green/card-checkout-green.component';
import { CardComparativoComponent } from './card-comparativo/card-comparativo.component';
import { CardLicencaComponent } from './card-licenca/card-licenca.component';
import { CardMaterialComponent } from './card-material/card-material.component';
import { CardTesteComponent } from './card-teste/card-teste.component';
import { GrupoTestesComponent } from './grupo-testes/grupo-testes.component';
import { ListagemTestesPorTipoComponent } from './listagem-testes-por-tipo/listagem-testes-por-tipo.component';
import { PessoalLicencasRoutingModule } from './pessoal-licencas-routing.module';
import { PessoalLicencasComponent } from './pessoal-licencas.component';

@NgModule({
    declarations: [
        PessoalLicencasComponent,
        CardLicencaComponent,
        CardTesteComponent,
        GrupoTestesComponent,
        CardMaterialComponent,
        CardComparativoComponent,
        CardCheckoutGreenComponent,
        SafeUrlPipe,
        ListagemTestesPorTipoComponent
    ],
    imports: [
        CommonModule,
        PessoalLicencasRoutingModule,
        TabelaListagemModule,
        ContainerPadraoModule,
        MatCardModule,
        MatButtonModule,
        MatIconModule,
        MatPaginatorModule,
        LoaderPageModule,
        MatProgressBarModule,
        MatTooltipModule,
        FormularioDinamicoModule,
        CardModule,
        ToolbarModule,
        StatusBadgeModule,
        A11yModule
    ],
    providers: [LicencasService, DialogService, JogadaService, MetadadosService]
})
export class PessoalLicencasModule { }
